import {
  ClipboardIcon,
  HomeIcon,
  UserIcon,
  BookmarkIcon,
  MicrophoneIcon,
  BookOpenIcon,
  QuestionMarkCircleIcon,
  TicketIcon,
  ShoppingCartIcon,
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { LMS_COURSE_ID } from '../../constants/types/lms/type';

const HOME_ITEMS = [
  {
    label: '과제 관리',
    key: 'assignment',
    icon: <ClipboardIcon className="h-6 w-6" />,
    children: [
      {
        label: <Link to={`./assignment/create`}>과제 내주기</Link>,
        key: 'assignment-create',
      },
      {
        label: <Link to={`./assignment/status`}>과제 현황보기</Link>,
        key: 'assignment-status',
      },
    ],
  },
  {
    label: 'AI인증제 관리',
    key: 'recitation',
    icon: <MicrophoneIcon className="h-6 w-6" />,
    children: [
      {
        label: <Link to={`./recitation/create`}>AI인증제 내주기</Link>,
        key: 'recitation-create',
      },
      {
        label: <Link to={`./recitation/status`}>AI인증제 현황보기</Link>,
        key: 'recitation-status',
      },
    ],
  },
  {
    label: <Link to={`./voucher`}>이용권 관리</Link>,
    key: 'voucher',
    icon: <TicketIcon className="h-6 w-6" />,
  },
];

const CHURCH_ITEMS = [
  {
    label: '과제 관리',
    key: 'assignment',
    icon: <ClipboardIcon className="h-6 w-6" />,
    children: [
      {
        label: <Link to={`./assignment/create`}>과제 내주기</Link>,
        key: 'assignment-create',
      },
      {
        label: <Link to={`./assignment/status`}>과제 현황보기</Link>,
        key: 'assignment-status',
      },
    ],
  },
  {
    label: <Link to={`./voucher`}>이용권 관리</Link>,
    key: 'voucher',
    icon: <TicketIcon className="h-6 w-6" />,
  },
];

/**
 * 사이드 메뉴 리스트
 * @param courseType 현재 코스의 분류
 * @returns 사이드 메뉴 리스트
 */
export const SidebarItems = (
  courseName: keyof typeof LMS_COURSE_ID | 'OTHERS' | '',
) => [
  {
    label: <Link to={`./dashboard`}>클래스 홈</Link>,
    key: 'dashboard',
    icon: <HomeIcon className="h-6 w-6" />,
  },
  {
    label: (
      <Link
        to={`./take-class`}
        onClick={(event) => {
          if (!location.pathname.endsWith('/take-class')) return;

          event.preventDefault();
          window.location.reload();
        }}
      >
        수업자료 보기
      </Link>
    ),
    key: 'take-class',
    icon: <BookOpenIcon className="h-6 w-6" />,
  },
  ...(courseName === 'BASIC' ? HOME_ITEMS : []),
  ...(courseName === 'WMW' || courseName === 'HFHJ' ? CHURCH_ITEMS : []),
  {
    label: <Link to={`./membership-store`}>멤버십 스토어</Link>,
    key: 'membership-store',
    icon: <ShoppingCartIcon className="h-6 w-6" />,
  },
  // {
  //   label: '수업 관리',
  //   key: 'management',
  //   icon: <ClipboardIcon className="h-6 w-6" />,
  //   children: [
  //     {
  //       label: <Link to={`./course-management`}>코스관리</Link>,
  //       key: 'course-management',
  //     },
  //     {
  //       label: <Link to={`./take-class`}>수업하기</Link>,
  //       key: 'take-class',
  //     },
  //   ],
  // },
  // ...SidebarTodoList(menuExposure), // 코스 분류 별 할 일 관리 리스트 (영어교실 베이직 / 교회학교 HFHJ, WMW / 그 외)
  ...(courseName === 'BASIC' || courseName === 'WMW' || courseName === 'HFHJ'
    ? [
        {
          label: <Link to={`./signup-management`}>학생 관리</Link>,
          key: 'signup-management',
          icon: <UserIcon className="h-6 w-6" />,
          // children: [
          //   {
          //     label: <Link to={`./signup-management`}>학생 관리</Link>,
          //     key: 'signup-management',
          //   },
          //   {
          //     label: <Link to={`./migration`}>구버전 학생 가져오기</Link>,
          //     key: 'migration',
          //   },
          // ],
        },
      ]
    : []),
  {
    label: <Link to={`./reference-room`}>자료실</Link>,
    key: 'reference-room',
    icon: <BookmarkIcon className="h-6 w-6" />,
  },
  // {
  //   label: <Link to={`./event`}>이벤트</Link>,
  //   key: 'event',
  //   icon: <GiftIcon className="h-6 w-6" />,
  // },
  {
    label: <Link to={`./dashboard`}>LMS 이용 가이드</Link>,
    key: 'lms-guide',
    icon: <QuestionMarkCircleIcon className="h-6 w-6" />,
    onClick: () => {
      if (
        courseName === 'KIDS' ||
        courseName === 'BASIC' ||
        courseName === 'ADVANCED'
      ) {
        window.open(
          'https://cafe.naver.com/f-e/cafes/27682530/menus/74?viewType=L',
          '_blank',
        );
      } else {
        window.open(
          'https://cafe.naver.com/f-e/cafes/21360034/menus/159?viewType=L',
          '_blank',
        );
      }
    },
  },
  // {
  //   label: '클래스 설정',
  //   key: '5',
  //   icon: <Cog8ToothIcon className="h-6 w-6" />,
  //   onClick: () => {
  //     alert('준비중인 기능입니다.');
  //   },
  // },
];
